import React, { useState } from 'react';
import { usePendingUsers, useRemoveUser, useAcceptUser } from '../services/dashboardService';
import './Dashboard.css'; // Import the CSS file

const Dashboard = () => {
  const { pendingUsers, error, refreshPendingUsers } = usePendingUsers();
  const { removeUser, error: removeUserError } = useRemoveUser(refreshPendingUsers);
  const { acceptUser, error: acceptUserError } = useAcceptUser(refreshPendingUsers);
  
  // State to manage loading status
  const [loading, setLoading] = useState(false);

  // Helper function to format dates
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(); // Format the date as MM/DD/YYYY
  };

  const handleRemoveUser = async (message_id) => {
    setLoading(true); // Set loading state to true
    try {
      await removeUser(message_id);
    } finally {
      setLoading(false); // Set loading state back to false after operation
    }
  };

  const handleAcceptUser = async (message_id, email, firstName, lastName) => {
    setLoading(true); // Set loading state to true
    try {
      await acceptUser(message_id, email, firstName, lastName);
    } finally {
      setLoading(false); // Set loading state back to false after operation
    }
  };

  return (
    <div id="root" className="d-flex justify-content-center mt-5">
      <div className="bg-white rounded shadow p-4 col-lg-8 col-sm-12 h-50">
        <h2>Pending Users</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        {removeUserError && <div className="alert alert-danger">{removeUserError}</div>}
        {acceptUserError && <div className="alert alert-danger">{acceptUserError}</div>}
        {pendingUsers.length === 0 ? (
          <div className="alert alert-info">No pending users at the moment.</div>
        ) : (
          <table className="table font-14 table-hover table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Sign Up Date</th>
                <th scope="col">First</th>
                <th scope="col">Last</th>
                <th scope="col">Email</th>
                <th scope="col">Sign Up Expires on</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {pendingUsers.map((pendingUser, index) => (
                <tr key={pendingUser.email} className="user-row">
                  <th scope="row">{index + 1}</th>
                  <td>{formatDate(pendingUser.created_at)}</td>
                  <td>{pendingUser.first_name}</td>
                  <td>{pendingUser.last_name}</td>
                  <td>{pendingUser.email}</td>
                  <td>{formatDate(pendingUser.expires_at)}</td>
                  <td className="action-buttons d-flex justify-content-center">
                    <button
                      className="btn btn-success mr-3"
                      onClick={() =>
                        handleAcceptUser(
                          pendingUser.id,
                          pendingUser.email,
                          pendingUser.first_name,
                          pendingUser.last_name
                        )
                      }
                    >
                      Accept
                    </button>
                    <button
                      className="btn btn-danger ml-3"
                      onClick={() => handleRemoveUser(pendingUser.id)}
                    >
                      Decline
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {loading && (
          <div className="overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
